import { Star, ExternalLink } from "lucide-react";
import { Placeholder, isPlaceholder } from "./Placeholder";

export const Stars = ({ rating = 5 }) => (
  <span className="flex gap-0.5" role="img" aria-label={`${rating} out of 5 stars`}>
    {Array.from({ length: 5 }).map((_, i) => (
      <Star
        key={i}
        className={`h-4 w-4 ${i < rating ? "fill-brand-amber text-brand-amber" : "text-slate-300"}`}
        aria-hidden="true"
      />
    ))}
  </span>
);

export const ReviewCard = ({ review, index = 0 }) => (
  <article
    data-testid={`review-card-${index}`}
    className="flex h-full flex-col gap-4 rounded-3xl border border-brand-line bg-white p-6 shadow-sm transition-[box-shadow,transform] duration-300 hover:-translate-y-1 hover:shadow-xl"
  >
    <Stars rating={review.rating} />
    {isPlaceholder(review.text) ? (
      <Placeholder>{review.text}</Placeholder>
    ) : (
      <blockquote className="text-base leading-relaxed text-slate-700">
        “{review.text}”
      </blockquote>
    )}
    <footer className="mt-auto flex flex-wrap items-center justify-between gap-2 border-t border-brand-line pt-4">
      <div>
        {isPlaceholder(review.name) ? (
          <Placeholder>{review.name}</Placeholder>
        ) : (
          <p className="font-display text-sm font-bold text-brand-ink">{review.name}</p>
        )}
        <p className="mt-1 text-xs text-brand-muted">
          {isPlaceholder(review.date) ? <Placeholder>{review.date}</Placeholder> : review.date}
        </p>
      </div>
      {!isPlaceholder(review.link) && review.link ? (
        <a
          href={review.link}
          target="_blank"
          rel="noopener noreferrer"
          data-testid={`review-google-link-${index}`}
          className="inline-flex items-center gap-1 text-xs font-semibold text-brand transition-colors hover:text-brand-dark"
        >
          View on Google <ExternalLink className="h-3 w-3" aria-hidden="true" />
        </a>
      ) : (
        <span className="text-xs text-brand-muted">Google review link pending</span>
      )}
    </footer>
  </article>
);
